import React, {useState, useCallback, useEffect} from 'react';
import {compose} from 'recompose';
import styled from 'styled-components';
import {hot} from 'react-hot-loader';
import {Modal, Header, Icon, Button, Form} from 'semantic-ui-react';

import {withLocale} from 'op/components/locale';
import {withReportRemarks} from './remark-modal.helper';



const RemarkModal = ({locale, readOnly, value, onChange}) => {
    const [openModal, setOpenModal] = useState(false);
    const [fieldValue, setFieldValue] = useState(value);

    const onSave = useCallback(() => {
        onChange(fieldValue);
        setOpenModal(false);
    });

    useEffect(() => {
        setFieldValue(value);
    }, [value]);

    return (
        <Modal
            trigger={
                <Icon style={{margin: 'auto 10px auto 0'}} name={!!(value || readOnly) ? 'info circle' : 'edit'}
                      onClick={() => setOpenModal(true)}/>
            }
            open={openModal}
            onClose={() => setOpenModal(false)}
            style={{direction: locale._meta.rtl ? 'rtl' : 'ltr'}}
        >
            <Header icon='edit' content={locale.title}/>
            <Modal.Content>
                <Form>
                    <Form.TextArea
                        lable={locale.title}
                        value={fieldValue}
                        readOnly={readOnly}
                        onChange={(e) => setFieldValue(e.target.value)}/>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={() => setOpenModal(false)} floated='left'>
                    <Icon name='remove'/> {locale._system.close}
                </Button>
                <Button disabled={readOnly} onClick={onSave} primary>
                    <Icon name='save'/> {locale._system.save}
                </Button>
            </Modal.Actions>
        </Modal>
    );
}

export default compose(
    hot(module),
    withReportRemarks,
    withLocale('report.remarks'),
)(RemarkModal);
